import { axiosWithToken } from "../../utils/axios";

export async function postContactAuthed({ data }:any) {
  try {
    const res = await axiosWithToken.post("/contact-authed/", { data, isToken: true });
    return res;
  } catch (error) {
    return false;
  }
}